var _excluded = ["className", "variant", "size", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledLoader from './loader.styles';
import StyledIcon from './styles/loader.icon.styles';
import StyledIconPath from './styles/loader.iconpath.styles';
var LoaderRequiredProps = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Add utility objects for styling */
  utils: PropTypes.object,
  /** Size variant */
  size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
  /** Color variant */
  variant: PropTypes.oneOf(['inverse', 'multi-color'])
};
var defaultProps = {
  className: '',
  utils: {},
  size: null,
  variant: null
};

/**
 * @ignore @description
 * ## Loader Component
 * Use the Loader component to create a visual indicator for loading content.
 *
 * @ignore @see Mesh: [Loader Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/visual-elements-loader--default)
 *
 * @ignore @example
 * ```jsx
 * import { Loader } from 'mesh-component-library';
 *
 * <Loader {...props}/>
 * ```
 */

var Loader = function Loader(props) {
  var className = props.className,
    variant = props.variant,
    size = props.size,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledLoader, _extends({
    role: "progressbar",
    utils: utils,
    className: className
  }, other), /*#__PURE__*/React.createElement(StyledIcon, {
    size: size,
    "aria-hidden": "true",
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement(StyledIconPath, {
    variant: variant,
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "6",
    strokeMiterlimit: "10"
  })));
};
Loader.propTypes = LoaderRequiredProps;
Loader.defaultProps = defaultProps;
export default Loader;